import React from 'react';

/**
 * VueNexa equalizer mark + wordmark.
 * `variant="dark"`  → dark ink text (use on light backgrounds)
 * `variant="light"` → white text + cyan tag (use on the dark brand panel)
 */
const BrandLockup: React.FC<{ variant?: 'dark' | 'light'; size?: number }> = ({
  variant = 'dark',
  size = 40,
}) => {
  const onLight = variant === 'dark';
  const bars = onLight
    ? ['#00a5bd', '#008abb', '#0055a9', '#008abb', '#00a5bd']
    : ['#8fd6ea', '#41b4d6', '#ffffff', '#41b4d6', '#8fd6ea'];
  return (
    <div className="flex items-center" style={{ gap: size * 0.32 }} role="img" aria-label="VueNexa Enterprise">
      <svg width={size} height={size} viewBox="0 0 64 64" fill="none">
        <rect x="3" y="8" width="8" height="24" rx="4" fill={bars[0]} />
        <rect x="15.5" y="8" width="8" height="36" rx="4" fill={bars[1]} />
        <rect x="28" y="8" width="8" height="48" rx="4" fill={bars[2]} />
        <rect x="40.5" y="8" width="8" height="36" rx="4" fill={bars[3]} />
        <rect x="53" y="8" width="8" height="24" rx="4" fill={bars[4]} />
      </svg>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: size * 0.22 }}>
        <span
          style={{
            fontFamily: "'Space Grotesk', sans-serif",
            fontSize: size * 0.7,
            fontWeight: 600,
            letterSpacing: '-0.03em',
            color: onLight ? '#141b24' : '#ffffff',
          }}
        >
          VueNexa
        </span>
        <span
          style={{
            fontFamily: "'Space Grotesk', sans-serif",
            fontSize: size * 0.275,
            fontWeight: 400,
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            color: onLight ? '#0055a9' : '#8fd6ea',
          }}
        >
          Enterprise
        </span>
      </div>
    </div>
  );
};

export default BrandLockup;
